/**
 * Formats a date to match the format: 'dddd, MMMM Do YYYY, h:mm:ss a'
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted date string
 */
export const formatDate = date => {
    if (!date) return '';

    const parsedDate = new Date(date);

    // Check for invalid date
    if (isNaN(parsedDate.getTime())) return '';

    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];

    const dayName = days[parsedDate.getDay()];
    const monthName = months[parsedDate.getMonth()];
    const dayOfMonth = parsedDate.getDate();
    const year = parsedDate.getFullYear();

    // Add ordinal suffix (1st, 2nd, 3rd, etc.)
    const getOrdinalSuffix = day => {
        if (day >= 11 && day <= 13) return 'th';
        switch (day % 10) {
            case 1:
                return 'st';
            case 2:
                return 'nd';
            case 3:
                return 'rd';
            default:
                return 'th';
        }
    };

    const dayWithOrdinal = `${dayOfMonth}${getOrdinalSuffix(dayOfMonth)}`;

    // Format time in 12-hour format
    let hours = parsedDate.getHours();
    const minutes = parsedDate.getMinutes().toString().padStart(2, '0');
    const seconds = parsedDate.getSeconds().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be 12

    return `${dayName}, ${monthName} ${dayWithOrdinal} ${year}, ${hours}:${minutes}:${seconds} ${ampm}`;
};

/**
 * Formats a date to: 'lll' (Sep 4, 1986 8:30 PM)
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted date string
 */
export const formatDateShort = date => {
    if (!date) return '';

    const parsedDate = new Date(date);

    // Check for invalid date
    if (isNaN(parsedDate.getTime())) return '';

    const shortMonths = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];

    const monthName = shortMonths[parsedDate.getMonth()];
    const dayOfMonth = parsedDate.getDate();
    const year = parsedDate.getFullYear();

    // Format time in 12-hour format
    let hours = parsedDate.getHours();
    const minutes = parsedDate.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be 12

    return `${monthName} ${dayOfMonth}, ${year} ${hours}:${minutes} ${ampm}`;
};
